<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="controls" :label="$lang.controls" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-if="controls" v-model="showRipple" :label="$lang.ripple" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown v-if="controls" :items="positions" v-model="position" width="128px" icon="directions-fork" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24" v-if="rerendered">
        <parallax @item-slide="onItemSlide" :width="width" :height="height" :aspect-ratio="aspectRatio" :class="['shadow-lg']">
          <template v-slot:controls>
            <parallax-controls :show-ripple="showRipple" :background="background" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" v-if="controls" :position="position[0]" :visible="visible" />
          </template>
          <template v-slot:items>
            <parallax-item :color="color" :color-lightness="colorLightness" :x-align="xAlign" :y-align="yAlign" :bg-image="`${$root.config.staticAssetsDir}/images/misc/stormy-weather-at-freshwater-bay.jpg`">
              <lorem-ipsum :class="['p-8', 'text-2xl']" />
            </parallax-item>
            <parallax-item :color="color" :color-lightness="colorLightness" :x-align="xAlign" :y-align="yAlign" :bg-image="`${$root.config.staticAssetsDir}/images/misc/autumn.jpg`">
              <lorem-ipsum :class="['p-8', 'text-2xl']" />
            </parallax-item>
            <parallax-item :color="color" :color-lightness="colorLightness" :x-align="xAlign" :y-align="yAlign" :bg-image="`${$root.config.staticAssetsDir}/images/misc/green.jpg`">
              <lorem-ipsum :class="['p-8', 'text-2xl']" />
            </parallax-item>
            <parallax-item :color="color" :color-lightness="colorLightness" :x-align="xAlign" :y-align="yAlign" :bg-image="`${$root.config.staticAssetsDir}/images/misc/sky.jpg`">
              <lorem-ipsum :class="['p-8', 'text-2xl']" />
            </parallax-item>
            <parallax-item :color="color" :color-lightness="colorLightness" :x-align="xAlign" :y-align="yAlign" :bg-image="`${$root.config.staticAssetsDir}/images/misc/broken.jpg`">
              <lorem-ipsum :class="['p-8', 'text-2xl']" />
            </parallax-item>
          </template>
        </parallax>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageParallax',
  mixins: [
    methods
  ],
  data () {
    return {
      rerendered: true,
      visible: 1,
      showRipple: true,
      width: null,
      height: null,
      background: 'rgba(0, 0, 0, .5)',
      yAlign: 'middle',
      xAlign: 'center',
      aspectRatio: '16:9',
      color: 'white',
      controls: false,
      colorLightness: null,
      position: ['top'],
      positions: [{
        text: 'Top',
        value: 'top'
      }, {
        text: 'Right',
        value: 'right'
      }, {
        text: 'Bottom',
        value: 'bottom'
      }, {
        text: 'Left',
        value: 'left'
      }]
    }
  },
  watch: {
    position () {
      this.repaint()
    },
    controls () {
      this.repaint()
    }
  },
  methods: {
    repaint () {
      this.rerendered = false
      this.$nextTick(() => {
        this.rerendered = true
      })
    },
    onItemSlide ($event) {
      this.log('item-slide', 'parallax', $event)
    }
  }
}
</script>
<style>
.bcq-parallax-item-back
{
  filter: grayscale(100%) brightness(50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/ui/parallax.vue